// Primeiro import do bundle, de proposito: garante que erros de carregamento
// dos modulos abaixo ja sejam capturados pelo Sentry.
import "./instrument";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import { Router } from "./routes/router";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "react-hot-toast";
import { toasterStyles } from "./styles/toaster";
import { ChatNotificationsProvider } from "./context/ChatNotificationsContext";
import { ErrorBoundary } from "./components/ErrorBoundary";

const queryClient = new QueryClient();


createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <ChatNotificationsProvider>
          <Toaster toastOptions={toasterStyles} />
          <Router />
        </ChatNotificationsProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  </StrictMode>,
);
